/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2026
///                                     RXO Inc.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of RXO Inc. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import Spinner from "../../icons/Spinner";

function InProgressBannerContent({ message }) {
  return (
    <div className="flex flex-row items-center h-52">
      <Spinner
        height="24"
        width="24"
        fill="#ADAFB2"
        className="spinner mr-8"
      />
      <p className="font-size-14 mb-0">{message}</p>
    </div>
  );
}

export default InProgressBannerContent;
